import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import ModalCarga from '../ModalCarga';

class Mermas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            tipo: 'registro',
            data: [],
            mermaSeleccionada: [],
        }
    }

    componentDidMount = async () => {
        this.select();
    }

    componentDidUpdate = (prevProps) => {
        if ((prevProps.idSucursal !== this.props.idSucursal) || (prevProps.fecha !== this.props.fecha)) {
            this.select()
            this.setState({
                mermaSeleccionada: []
            })
        }
    }

    numberWithCommas = (x) => {
        x = Number(x).toFixed(2);
        if (x === 0) {
            return '0.00';
        }else{
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    select = async () => {  
        this.setState({ loading: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'mermas', idSucursal: this.props.idSucursal, fecha: this.props.fecha })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/reportes.php', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.error === 0) {
            this.setState({
                data: data,
                loading: false
            })
        }else{
            this.setState({
                loading: false
            })
            toast.error('Error al obtener datos');
            console.log(data.mensaje);
        }
    }

    selectMerma = async (e) => {
        this.setState({ loading: true });
        let idMerma = e.target.id;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'selectMerma', idMerma: idMerma })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/reportes.php', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.error === 0) {
            this.setState({
                mermaSeleccionada: data,
                loading: false
            })
        }else{
            this.setState({
                loading: false
            })
            toast.error('Error al obtener datos');
            console.log(data.mensaje);
        }
    }

    onChangeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    getTotalPiezas = () => {
        let total = 0;
        if (this.state.data.porDia) {
            for (let index = 0; index < this.state.data.porDia.length; index++) {
                total = total + Number(this.state.data.porDia[index].total_merma_cantidad);
            }
        }
        return total;
    }

    getTotalMermas = () => {
        let total = 0;
        if (this.state.data.porDia) {
            for (let index = 0; index < this.state.data.porDia.length; index++) {
                total = total + Number(this.state.data.porDia[index].total_merma_dinero);
            }
        }
        return total;
    }

    render() { 
        return ( 
            <>
                <ModalCarga show={this.state.loading}/>
                <div className="col-2">
                    <label className='ms-1' htmlFor="tipo">Tipo</label>
                    <select name="tipo" id="tipo" className='form-control' value={this.state.tipo} onChange={this.onChangeValue}>
                        <option value="dia">Por Dia</option>
                        <option value="registro">Por Registro</option>
                    </select>
                </div>
                <div className="col-12 mt-5"/>
                {
                    (this.state.tipo === 'dia' && this.state.data.porDia) &&
                        <div className="col-6 mx-auto">
                            <Table bordered striped>
                                <thead className='bg-black text-white'>
                                    <tr>
                                        <th>ID del Producto</th>
                                        <th>Producto</th>
                                        <th>Cantidad Mermada</th>
                                        <th>Venta Mermada</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.data.porDia &&
                                            this.state.data.porDia.map((e) =>                                            
                                            <tr key={e.idProducto}>
                                                <td className='text-center'>{e.idProducto}</td>
                                                <td className='w-50'>{e.nombre}</td>
                                                <td className='text-center'>{e.total_merma_cantidad}</td>
                                                <td className='text-end'>{'$' + this.numberWithCommas(e.total_merma_dinero)}</td>
                                            </tr>                                            
                                    )
                                    }
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td className='text-center bg-black text-white'>{this.getTotalPiezas()}</td>
                                        <td className='text-end bg-black text-white'>{'$' + this.numberWithCommas(this.getTotalMermas())}</td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                }
                {
                     (this.state.tipo === 'registro' && this.state.data.porRegistro) &&
                     <>
                        <div className="col-3 mb-4 mx-auto" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                            <Table bordered striped>
                                <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                    <tr>
                                        <th>Hora</th>
                                        <th>Piezas</th>
                                        <th>Usuario</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.data.porRegistro &&
                                            this.state.data.porRegistro.map((e) =>                                            
                                            <tr key={e.idMerma} id={e.idMerma} onClick={this.selectMerma} style={{ fontWeight: this.state.mermaSeleccionada.idMerma === e.idMerma ? 'bold' : '' }}>
                                                <td className='text-center' id={e.idMerma}>{new Date(e.fecha).toLocaleTimeString()}</td>
                                                <td className='text-end' id={e.idMerma}>{e.piezas}</td>
                                                <td className='' id={e.idMerma}>{e.usuario}</td>
                                            </tr>
                                    )
                                    }
                                </tbody>
                            </Table>
                        </div>
                        <div className="col-7 mb-4 mx-auto" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                            {
                                this.state.mermaSeleccionada.idMerma ?
                                    <Table striped>
                                        <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                            <tr>
                                                <th className='text-center' colSpan={4}>Detalles de la Merma</th>
                                            </tr>
                                            <tr>
                                                <th className='text-center col-4'>Hora</th>
                                                <th className='text-center col-4'>Usuario</th>
                                                <th className='text-center col-4'>Total de piezas</th>
                                                <th className='text-center col-4'>Venta Mermada</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th className='text-center'>{new Date(this.state.mermaSeleccionada.fecha).toLocaleTimeString()}</th>
                                                <th className='text-center'>{this.state.mermaSeleccionada.usuario}</th>
                                                <th className='text-center'>{this.state.mermaSeleccionada.piezas}</th>
                                                <th className='text-center'>{'$' + this.numberWithCommas(this.state.mermaSeleccionada.total)}</th>
                                            </tr>
                                            <tr className='table-group-divider'>
                                                <th>Producto</th>
                                                <th className='text-center'>Precio Unitario</th>
                                                <th className='text-center'>Cantidad</th>
                                                <th className='text-center'>Importe</th>
                                            </tr>
                                            {
                                                this.state.mermaSeleccionada.productos.map((e) =>                                            
                                                    <tr key={e.idProductoMerma}>
                                                        <td className=''>{e.nombre}</td>
                                                        <td className='text-center'>{'$' + this.numberWithCommas(e.precioUnitario)}</td>
                                                        <td className='text-center'>{e.cantidad}</td>
                                                        <td className='text-end'>{'$' + (Number(e.precioUnitario)*Number(e.cantidad))}</td>
                                                    </tr>                                            
                                                    )
                                            }
                                        </tbody>
                                    </Table>
                                :
                                <h1 className='text-center'>Seleccione una merma para ver el detalle</h1>
                            }
                        </div>
                    </>
                }
            </>
         );
    }
}
 
export default Mermas;